"use client";

import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import ApplyForm from "./ApplyForm";

export default function ApplyFormWrapper({
  subjectNames,
}: {
  subjectNames: string[];
}) {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY as string}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: "head",
      }}
    >
      <ApplyForm subjectNames={subjectNames} />
    </GoogleReCaptchaProvider>
  );
}
